import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import CardHeadMenu from "../../../Components/Card/CardHeadMenu/CardHeadMenu";
import { useSelector } from "react-redux";
import configServ from "../../../services/config";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import PaymentForm from "./PaymentForm";
import PaymentTable from "./PaymentTable";

const PaymentPage = () => {
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);

  const [isCreate, setIsCreate] = useState(false);
  const [getwayData, setGetwayData] = useState([]);
  const [loading, SetLoading] = useState(true);
  const [searchBy, setSearchBy] = useState("getway_name");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [editPaymentData, setEditPaymentData] = useState(null); // stores the data for editing
  const [isEdit, setIsEdit] = useState(false);
 

  const fetchGeteway = async () => {
    try {
      SetLoading(true);
      const payload = {
        company_id: company_id,
        search_by: searchBy,
        search,
        page: page + 1,
        per_page: perPage,
      };
      const res = await configServ.getAllPaymentGateways(payload);
      if (res.status) {
        setGetwayData(res.data);
        setTotal(res.total);
      }
    } catch (error) {
      console.error("Failed to fetch getways", error);
    } finally {
      SetLoading(false);
    }
  };

  const firstSearchLoad = useRef(true); // to prevent double fetch

  useEffect(() => {
    if (firstSearchLoad.current) {
      firstSearchLoad.current = false;
      return; // skip first auto-fetch here
    }

    setPage(0); // ✅ reset page if search/searchBy changes
  }, [search, searchBy]);

  const debouncedFetch = useCallback(
    debounce(() => {
      fetchGeteway();
    }, 500),
    [search, searchBy, page, perPage]
  );

  useEffect(() => {
    debouncedFetch();
    return debouncedFetch.cancel;
  }, [search, searchBy, page, perPage]);

  const handlePopup = () => {
    try {
      setIsCreate(!isCreate);
      setEditPaymentData(null)
      setIsEdit(false)
    } catch (e) {
      console.log(e);
    }
  };
  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  
  const handleEdit = (payments) => {
    setEditPaymentData(payments); // Save the data
    setIsCreate(true); // Open the form
    setIsEdit(true)
    scrollUp();
  };

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Payment Configuration"}
        handlePopup={handlePopup}
        // isEdit={isEdit}
        create={isCreate}
        // showCreate={Boolean(is_super || is_admin || permissions?.includes(25))}
      />
      <AnimatePresence>
        {isCreate === true && (
          <PaymentForm
            isCreate={isCreate}
            setIsCreate={setIsCreate}
            onSuccess={fetchGeteway}
            editData={editPaymentData}
            isEdit={isEdit}
            setEditPaymentData={setEditPaymentData}
            setIsEdit={setIsEdit}
          />
        )}
      </AnimatePresence>
      <PaymentTable
        getwayData={getwayData}
        loading={loading}
        searchBy={searchBy}
        search={search}
        page={page}
        perPage={perPage}
        total={total}
        setGetwayData={setGetwayData}
        SetLoading={SetLoading}
        setSearchBy={setSearchBy}
        setSearch={setSearch}
        setPage={setPage}
        setPerPage={setPerPage}
        setTotal={setTotal}
        handleEdit={handleEdit}
      />
    </>
  );
};

export default PaymentPage;
